import {useEffect, useState} from "react";
import {Box, Button, Divider, List, Typography} from "@mui/material";
import httpReq from "../../services/httpReq";
import {ColorPalette} from "../../consts/ColorPalette";
import * as lod from "lodash";
import AddIcon from "@mui/icons-material/Add";
import ProjectListItem from "./ProjectListItem";
import ModalManageProject from "../modals/asiaEditProject/ModalManageProject";
import {useDispatch, useSelector} from "react-redux";
import {toggleProjectOpen} from "../../store/reducers/projects";

const ProjectsListContainer = () => {
    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [reloadProjectsList, setReloadProjectsList] = useState(false);
    const [projectModalOpen, setProjectModalOpen] = useState(false);

    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);

    useEffect(() => {
        if (isLoading || isLoaded) return;
        setIsLoading(true);
        httpReq('Project/GetList', 'GET', null, true).then(res => {
            console.log('res project list ---> ', res)
            if (!res || res.responseAnyError) return
            const items = [...res.responseData].map((item, k) => {
                const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === item.id) : null;
                item.color = ColorPalette[k];
                if (!foundProject) {
                    item = {...item, isOpen: false};
                    dispatch(toggleProjectOpen(item));
                }
                else {
                    item = {...item, isOpen: foundProject.isOpen};
                }
                return item;
            });
            const p = lod.orderBy(items, ['name'], 'asc')
            setProjects(p);
        });
        setIsLoading(false);
        setIsLoaded(true);
        setReloadProjectsList(false);
    }, [isLoaded,isLoading, localStorageProjects,reloadProjectsList ])

    useEffect(() => {
        setIsLoaded(false);
    }, [localStorageProjects,reloadProjectsList]);


    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px solid',
                    borderColor: 'divider',
                    p: 2,
                    height: '100%',
                    bgcolor: 'background.paper',
                }}
            >
                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>Projects list</Typography>
                    <Button
                        onClick={() => setProjectModalOpen(true)}
                        variant="contained"
                        size="small"
                        startIcon={<AddIcon />}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Aggiungi
                    </Button>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <List disablePadding >
                    {projects.map((project, key) => (
                        <ProjectListItem setReloadProjects={setReloadProjectsList} key={`project-list-item-${key}`} project={project}/>
                    ))}
                </List>
            </Box>
            {!!projectModalOpen &&
                <ModalManageProject
                    setReloadProjects={setReloadProjectsList}
                    isOpen={!!projectModalOpen}
                    setIsOpen={setProjectModalOpen}
                    mode={'add'}
                    projectToEdit={null}
                />
            }

        </>
    )
}

export default ProjectsListContainer;